module.exports = function(posts) {
	'use strict'
  posts
  .controller('tagsController', tagsController)
	tagsController.$inject = ["watchAllCheckboxesNgTable","$stateParams","$state","$scope","$rootScope","NgTableParams", "getDataService","refreshtokenService","postDataService","alertService", "deleteDataService","putDataService","serverError","comunicateBetweenViews", "offlineError"]
	
  function tagsController(watchAllCheckboxesNgTable,$stateParams,$state,$scope,$rootScope,NgTableParams,getDataService,refreshtokenService, postDataService,alertService, deleteDataService, putDataService,serverError, comunicateBetweenViews, offlineError) {
    var vmt = this;
    vmt.tagEdit = false;
    var state = 'tags';
    var page;  
    var limit;
    var sortby;
    var s;
    var $data;
    $rootScope.alert={hasBeenShown: false};
    $rootScope.hasLoaded = false;
    vmt.selectedName = -1;
    vmt.hasParent = {items:{}};
    vmt.tagName = undefined;
    vmt.tagSlug = undefined;
    vmt.tagDescription= undefined;
    vmt.selectedBulkAction = {value: 'default'};
    vmt.checkedPostsEdit = [];
    vmt.checkboxes = { 'checked': false, items: {} };
    $rootScope.emptyTable = false;
    vmt.tagId = $stateParams.id; 
    if($stateParams.id) {
      vmt.tagEdit= true;
    } else {
      vmt.tagEdit = false;
    }
    vmt.goToAllPosts = function(tag) {
      comunicateBetweenViews.setTag(tag);
      $state.go('app.allposts'); 
    }
    vmt.editTag = function(tagId,tagCount) {
      vmt.tagEdit= true;
      jQuery("html, body").animate({
        scrollTop: 0
      }, 10);
      vmt.tagId = tagId;
      $state.transitionTo('app.tags', {id: vmt.tagId}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      });
    }
    vmt.addNewTag = function() {
    
      if(vmt.tagName) {
        $rootScope.hasLoaded = false;
        var postFunction = function() {
          postDataService.save({
            param1:'tags', 
            // param2: 'create'
          },{
            'name':vmt.tagName,
            "description": vmt.tagDescription,
            'slug':vmt.tagSlug
          }).$promise.then(function(postTag){ 
            vmt.tagName = undefined;
            vmt.tagSlug = undefined;
            vmt.tagDescription= undefined;
            alertService('success','Success ', postTag.message, 2000);
            $rootScope.hasLoaded = true;
            vmt.tableParams.reload();
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              $rootScope.hasLoaded = true;
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    postFunction();
                  }
                },
                function(error) {
                },
                function(progress) {
                 // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
              if(error && error.data && error.data.error && error.data.error.slug) {
                vmt.tagSlug = error.data.error.slug;
              }
            }
            $rootScope.hasLoaded = true;  
          });
        }
        postFunction();
      } else {
        alertService('danger','Opps! ', 'Tag is required')
        vmt.nameRequired=true;
      }
    }
    vmt.quickEdit = function(id) {
      vmt.selectedName = id;
    }
    vmt.cancelQuickEdit = function() {
      vmt.selectedName = -1;
    }
    vmt.reloadTable = function() {
      vmt.tableParams.reload()
    }
    vmt.updateBulkDeleteSuccess = function() {
      watchAllCheckboxesNgTable.resetCheckBox(vmt)
      vmt.selectedBulkAction = {value: 'default'};
      vmt.tableParams.reload(); 
    }
    watchAllCheckboxesNgTable.watch($scope,vmt)
    vmt.checkedPost = function(categoryId, checked) {
      if(checked) {
        vmt.checkedPostsEdit.push(categoryId);
      } else {

        if(vmt.checkedPostsEdit.includes(categoryId)) {
          var id_tag = categoryId;
          var position = vmt.checkedPostsEdit.indexOf(id_tag);
          vmt.checkedPostsEdit.splice(position, 1);
        }
      }
    }
    vmt.tableActionsFunction = function(params) {
      vmt.search =function(value) {
        if(value) {  
          s = value.toLowerCase();
        } else {
          s = null;
        }
        page = 1;
        params.page(page);
        vmt.tableParams.reload();
      }
    }
    vmt.tableReloadFunction = function(page) {
      vmt.tableParams = new NgTableParams({
        page: page || 1,
        count: 20,
              
        }, {
        getData: function(params) {
          $rootScope.hasLoaded = false;
          return getDataService.get({
            param1: state,
            param2: null,
            page: params.page(),
            limit: params.count(),
            sortby: $rootScope.sortby,
            sort : $rootScope.sort,
            s:s
            }).$promise.then(function(data){
           
            $rootScope.hasLoaded = true;
            $data =data.tags;
            vmt.dataGet = data.tags;
            params.total(data.count);
            params.numPages(data.max_pages);
            jQuery('.goTo input').val("");
            if(data.tags.length == 0) {
              $rootScope.emptyTable = true;
            } else {
              $rootScope.emptyTable = false;
            }
            watchAllCheckboxesNgTable.resetCheckBox(vmt)
            vmt.tableActionsFunction(params);  
            return $data;
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError('refresh')
              $rootScope.hasLoaded = true;
              return
            }
            if(error.status ==401) {
              
              var promise = refreshtokenService.getAccessToken();
              promise.then(
              function(answer) {
                if(answer==200) {
                  vmt.tableReloadFunction(params.page());
                }
                // do something
              },
              function(error) {
              },
              function(progress) {
               // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else if(error.status ==404) {
              $rootScope.emptyTable = true;
            } else {
              alertService('danger','Opps! ', error.data.error.message); 
            }
            $rootScope.hasLoaded = true;
            vmt.tableActionsFunction(params);
          });
        }    
      });   
    }
    vmt.tableReloadFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/tags/js/tagsController.js
// module id = 571
// module chunks = 0